export class EstadoModel{
    Id: number = 0;
    EmpresaId: number = 0;
    Nombre: string = '';
    Observaciones : string = '';
}